<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close btn-close-white" (click)="close()"></button>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
  <p>{{ detail }}</p>
  @if(traceId && traceId != ''){
    <p>Error Id: {{traceId}}</p>
    <p>Providing error details helps our developers troubleshoot issues. Would you like to send additional error details?</p>
    <button type="button" class="btn btn-danger" (click)="sendDetails()">
      <i class="fa-solid fa-lock me-2" [class]="{'fa-lock': !working, 'fa-spinner': working, 'fa-spin': working}"></i>Send Error Details
    </button>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
